import * as React from 'react';

import styles from './styles.module.scss';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	checked: boolean;
	onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
	checked,
	onChange,
}) => {

	const handleClick = React.useCallback((event: React.MouseEvent<HTMLInputElement>) => {
		event.stopPropagation();
	}, []);

	return (
		<div className={styles['select-checkbox']}>
			<input
				checked={checked}
				onChange={onChange}
				onClick={handleClick}
				readOnly={!onChange}
				type="checkbox"
			/>
		</div>
	);
};

export default React.memo(Checkbox);
